export default __webpack_public_path__ + "assets/c1dbbdc1b473d757ed94a80d6cff51f5.jpg";